import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialFloppyDisk: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 3.05H32v27.43h-1.53Zm-1.52-1.53h1.52v1.53h-1.52Zm-1.52 15.24H25.9v13.72H6.09V16.76H4.57v13.72H1.52V32h28.95v-1.52h-3.04zm-9.15-7.62h6.1V3.05h-6.1Zm1.53-4.57h1.52v3.05h-1.52Z\"/><path fill=\"currentColor\" d=\"M9.14 25.9h13.71v1.53H9.14Zm0-4.57h13.71v1.53H9.14Zm-3.05-6.09H25.9v1.52H6.09Zm-1.52-6.1h1.52V1.52h3.05v7.62H6.09v1.53h3.05v1.52h18.29V1.52h1.52V0H3.05v1.52h1.52Zm6.09-7.62H25.9v9.15H10.66Zm-9.14 0h1.53v1.53H1.52ZM0 3.05h1.52v27.43H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialFloppyDisk
